import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEyeOutline = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.75,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M2.75 12S6.25 5.75 12 5.75 21.25 12 21.25 12 17.75 18.25 12 18.25 2.75 12 2.75 12Z" }), /* @__PURE__ */ _jsx("circle", {
		cx: 12,
		cy: 12,
		r: 3.1
	})]
});
const ForwardRef = forwardRef(SvgEyeOutline);
export default ForwardRef;
